import { Horizon787MarketingSeo } from "../../../content/templateMarketing/horizon-787-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import horizon787Image from "../../images/templates/horizon-787.jpg";

export const horizon787Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "Horizon 787",
  id: "horizon-787",
  platforms: ["msfs"],
  image: horizon787Image,
  infoMarketingBlurb: Horizon787MarketingSeo,
  content: [
    {
      title: "Initial Preflight",
      roles: ["beforeFlightStart"],
      content: [
        { header: "Flight Deck Safety Inspection" },
        { item: "Battery Switch", setting: "On" },
        { item: "C1 & C2 Elec Pumps", setting: "Off" },
        { item: "Demand Pump Selectors", setting: "Off" },
        { item: "Nav Lights", setting: "On" },
        { item: "Logo Lights", setting: "As Req" },
        { item: "Landing Gear Lever", setting: "Down" },
        { item: "Parking Brake", setting: "Set" },
        { item: "Throttles", setting: "Idle" },
        { item: "Fuel Control Switches", setting: "Cutoff" },
        { header: "Establishing Power" },
        { item: "External Power", setting: "As Req / On" },
        { item: "APU", setting: "Start" },
        { item: "APU Generators", setting: "On" },
        { item: "Equipment Cooling", setting: "Auto" },
        { item: "Recirculation Fans", setting: "On" },
        { item: "Packs", setting: "Auto" },
        { item: "Trim Air Switches", setting: "On" },
        { item: "IRS", setting: "On" },
      ],
    },
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation", "beforePushback"],
      content: [
        { header: "Overhead Panel" },
        { item: "Battery Switch", setting: "On" },
        { item: "IFE/PASS Seats", setting: "On" },
        { item: "Cabin Utility", setting: "On" },
        { item: "Generator Control Switches", setting: "On" },
        { item: "Cockpit Door Power", setting: "On" },
        { item: "Emergency Lights", setting: "Armed & Guarded" },
        { item: "Window Heat", setting: "All On" },
        { item: "Passenger Signs", setting: "Auto" },
        { item: "EEC Mode Switches", setting: "Norm & Guarded" },
        { item: "Start Selectors", setting: "Norm" },
        { item: "Fuel Panel", setting: "Set" },
        { item: "Anti-Ice", setting: "Auto" },
        { item: "Pressurization Panel", setting: "Set" },
        { header: "Glareshield Panel" },
        { item: "Altimeter", setting: "Set Local" },
        { item: "Flight Director", setting: "On" },
        { item: "Autothrottle", setting: "Armed" },
        { item: "A/P DISENG Bar", setting: "Up" },
      ],
    },
    {
      title: "Cockpit Preparation (cont)",
      roles: ["cockpitPreparation", "beforePushback"],
      content: [
        { header: "Main Panel & Pedestal" },
        { item: "Autobrake", setting: "RTO" },
        { item: "ISFD", setting: "Check & Set" },
        { item: "Fuel Quantity", setting: "Check" },
        { item: "Speedbrake Lever", setting: "Down" },
        { item: "Flap Lever", setting: "Check Position" },
        { item: "Transponder", setting: "Stby" },
      ],
    },
    {
      title: "Before Start",
      roles: ["beforeEngineStart"],
      content: [
        { item: "APU", setting: "On" },
        { item: "External Power", setting: "Off & Disconnected" },
        { item: "Doors", setting: "Closed" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Main Hydraulic Pumps", setting: "On" },
        { item: "C1 & C2 Pumps", setting: "Auto" },
        { item: "Demand Pump Selectors", setting: "Auto" },
        { item: "Fuel Pumps", setting: "On" },
        { item: "Stab Trim", setting: "Set" },
        { item: "Rudder Trim", setting: "Zero" },
        { item: "Beacon", setting: "On" },
        { item: "Transponder", setting: "As Req / Stby" },
      ],
    },
    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        { item: "Left Start Selector", setting: "Start" },
        { item: "Left Fuel Control", setting: "Run" },
        { item: "Right Start Selector", setting: "Start" },
        { item: "Right Fuel Control", setting: "Run" },
        { item: "EICAS", setting: "Check Indications" },
      ],
    },
    {
      title: "Before Taxi",
      roles: ["afterEngineStart", "beforeTaxi"],
      content: [
        { item: "Start Selectors", setting: "Verify Norm" },
        { item: "Generators", setting: "Verify On" },
        { item: "APU", setting: "Off" },
        { item: "Anti-Ice", setting: "As Required" },
        { item: "Flight Controls", setting: "Check" },
        { item: "Autobrake", setting: "RTO" },
        { item: "Flaps", setting: "Set for Takeoff" },
        { header: "When Ready to Taxi" },
        { item: "Taxi Lights", setting: "On" },
        { item: "Rwy Turnoff Lights", setting: "As Req" },
      ],
    },
    "page-break",
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        { item: "Flaps", setting: "Verify Set" },
        { item: "Landing Lights", setting: "On" },
        { item: "Strobe Lights", setting: "On" },
        { item: "Taxi Lights", setting: "Off" },
        { item: "Rwy Turnoff Lights", setting: "Off" },
        { item: "Transponder", setting: "TA/RA" },
      ],
    },
    {
      title: "Climb",
      roles: ["climbOut"],
      content: [
        { item: "Landing Gear", setting: "Up" },
        { item: "Flaps", setting: "Up" },
        { item: "Engine Anti-Ice", setting: "As Req / Auto" },
        { item: "Autobrake", setting: "Off" },
        { item: "Transponder", setting: "TA/RA" },
        { header: "Passing 10,000 ft" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Logo Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "As Desired" },
        { header: "Passing Transition Altitude" },
        { item: "Altimeters", setting: "Set STD" },
      ],
    },
    {
      title: "Descent",
      roles: ["beforeDescent", "descent"],
      content: [
        { item: "Autobrake", setting: "As Req" },
        { item: "Minimums", setting: "Set" },
        { item: "Passenger Signs", setting: "As Desired" },
        { header: "Passing 10,000 ft" },
        { item: "Landing Lights", setting: "On" },
        { item: "Logo Lights", setting: "As Req / On" },
        { item: "Passenger Signs", setting: "As Desired" },
        { header: "Passing Transition Level" },
        { item: "Altimeters", setting: "Set Local" },
      ],
    },
    {
      title: "Landing",
      roles: ["approach", "landing"],
      content: [
        { item: "Altimeter", setting: "Set" },
        { item: "Autobrake", setting: "As Req" },
        { item: "Landing Gear", setting: "Down" },
        { item: "Flaps", setting: "Full" },
        { item: "Speed Brakes", setting: "Armed" },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        { item: "Rwy Turnoff Lights", setting: "As Req" },
        { item: "Taxi Lights", setting: "On" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Strobe Lights", setting: "Off" },
        { item: "Logo Lights", setting: "As Req / Off" },
        { item: "Speedbrake", setting: "Down" },
        { item: "Flaps", setting: "Up" },
        { item: "Transponder", setting: "As Req / Stby" },
        { item: "APU", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "WXR / TFC / TERR", setting: "Off" },
      ],
    },
    {
      title: "Parking",
      roles: ["shutdown", "parking"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Fuel Control Switches", setting: "Cutoff" },
        { item: "Hydraulic Pumps", setting: "Off" },
        { item: "Fuel Pumps", setting: "Off" },
        { item: "Anti-Ice", setting: "Auto" },
        { item: "Beacon", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "Flight Director", setting: "Off" },
        { item: "Transponder", setting: "Stby" },
        { item: "APU / EXT Power", setting: "As Required" },
        { item: "Cockpit Door", setting: "Unlock" },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        { item: "IRS Selectors", setting: "Off" },
        { item: "Packs / Recirc Fan", setting: "Off" },
        { item: "APU / External Power", setting: "As Req" },
        { item: "Battery Switch", setting: "Off" },
      ],
    },
  ],
};
